import React, {useEffect} from 'react';
import {StyleSheet, Platform, ScrollView} from 'react-native';
import {useForm, Controller} from 'react-hook-form';
import TextInput from '../../components/TextInput';
import Error from '../../components/Error';
import Button from '../../components/Button';
import {calculCSTA} from './calcul';
import {isPositiveNumber} from '../../utils';

const FormCSTA = ({jumpTo, setTotal, setCSTA, setITPER}) => {
  const {register, handleSubmit, control, errors, watch} = useForm({
    mode: 'onChange',
    defaultValues: {
      CANacresPerles: 0,
      CAAutresActivites: 0,
    },
  });

  const onSubmit = (values) => {
    const total = calculCSTA(values);
    setTotal(total.montantTotal);
    setCSTA(total.montantCSTA);
    setITPER(total.montantITPER);
    jumpTo ? jumpTo('second') : '';
  };

  const CANacresPerles = watch('CANacresPerles');
  const CAAutresActivites = watch('CAAutresActivites');

  useEffect(() => {
    register('CANacresPerles', {
      required: true,
      valueAsNumber: true,
      validate: (value) => isPositiveNumber(value),
    });

    register('CAAutresActivites', {
      required: true,
      valueAsNumber: true,
      validate: (value) => isPositiveNumber(value),
    });
  }, [register]);

  return (
    <ScrollView>
      <Controller
        control={control}
        name="CANacresPerles"
        render={(props) => (
          <TextInput
            onChangeText={props.onChange}
            value={props.value}
            label={`CHIFFRE D'AFFAIRES ANNUEL DES ACTIVITÉS NACRIÈRE ET PERLIÈRE (UNIQUEMENT) : ${CANacresPerles}`}
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />

      {errors.CANacresPerles?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.CANacresPerles?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="CAAutresActivites"
        render={(props) => (
          <TextInput
            onChangeText={props.onChange}
            value={props.value}
            label={`CHIFFRE D'AFFAIRES ANNUEL DES AUTRES ACTIVITÉS PRIMAIRES (AQUACOLE, AVICOLE, PÊCHE, ÉLEVAGE, …) : ${CAAutresActivites}`}
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />

      {errors.CAAutresActivites?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.CAAutresActivites?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Button onPress={handleSubmit(onSubmit)} label="Faire la simulation" />
    </ScrollView>
  );
};

const styles = StyleSheet.create({});

export default FormCSTA;
